import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import DetalhePositivacao from "./DetalhePositivacao/DetalhePositivacao";
import gestaodainfo from "../../assets/icons/gestaodainfo.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "95%",
  justifyContent: "flex-start",
  width: "100%",
});

function PositivacaoDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Positivação Geral");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);
  const [detail, setDetail] = useState("");
  const [detailMessage, setDetailMessage] = useState(0);

  const handleChange = (event) => {
    app.field("Tipo_POS").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  async function detailSelecao() {
    await app.variable.getContent("vSelecaoDet_Pos", (reply) => {
      const data = reply.qContent.qString;
      setDetail(data.substring(0, 15));
    });
  }

  useEffect(() => {
    detailSelecao();
    setDetailMessage(0);
    selections.map((s) => {
      if (s.qField === "Grupo Distribuição") {
        setDetailMessage(1);
      }
    });
  }, [selections]);

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_POS")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app positivacao">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            row
            defaultValue={"Positivação Geral"}
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Positivação Geral"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Positivação Geral"
            />

            <FormControlLabel
              value="Positivação Resumo"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Positivação Acum. Ano"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              {detail === "0" && detailMessage === 1 ? (
                <p
                  style={{
                    borderRadius: "8px",
                    border: "1px solid var(--Surface-Stroke-card, #F7F7F7)",
                    background: "var(--Surface-Card, #FFF)",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={gestaodainfo}
                    alt="gestaodainfo"
                    style={{ marginRight: "5px" }}
                  />
                  Selecione apenas{" "}
                  <span style={{ margin: "5px" }}>
                    <b>um mês</b>
                  </span>{" "}
                  para resultados detalhados
                </p>
              ) : (
                <></>
              )}

              {selectedValue === "Positivação Geral" ? (
                <div style={{ width: "100%", height: "90%" }}>
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Positivação",
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    exportContainer
                    exportTable
                    exportTableId="nHnkdZ"
                  >
                    <NativeObject
                      app={app}
                      key="nHnkdZ"
                      reference={{ id: "nHnkdZ" }}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Card>

                  {detail === "1" && (
                    <DetalhePositivacao app={app} config={config} />
                  )}
                </div>
              ) : null}

              {selectedValue === "Positivação Resumo" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Positivação",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="nHnkdZ"
                >
                  <NativeObject
                    app={app}
                    key="nHnkdZ"
                    reference={{ id: "nHnkdZ" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

PositivacaoDesktop.defaultProps = {
  app: null,
  config: {},
};

PositivacaoDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoDesktop;
